import { useQuery } from '@tanstack/react-query';
import { api, podatki } from '../api/odjemalec';

/** Prebrani podatek, ki se razlikuje od že vnesenega (uporabnik ga lahko uporabi z gumbom). */
export type Razlika = { kljuc: string; oznaka: string; trenutno: unknown; prebrano: unknown };

/** Polje obrazca je prazno: nič, prazen niz, 0 ali ne (privzete vrednosti obrazca vozila). */
export function prazno(v: unknown): boolean {
  return v === undefined || v === null || v === '' || v === 0 || v === false;
}

function enako(a: unknown, b: unknown): boolean {
  if (typeof a === 'number' && typeof b === 'number') {
    return Math.abs(a - b) < 0.001;
  }
  return String(a).trim().toUpperCase() === String(b).trim().toUpperCase();
}

/**
 * Prebrane podatke vpiše v prazna polja obrazca; za polja z drugačno vrednostjo vrne razlike (obrazec jih ne
 * spremeni). Upošteva samo polja iz {@code oznake} (ključ → oznaka polja), neznane ({@code null}) izpusti.
 */
export function zdruzi<T extends object>(
  obrazec: T,
  prebrano: Record<string, unknown>,
  oznake: Record<string, string>,
): { obrazec: T; izpolnjeno: string[]; razlike: Razlika[] } {
  const novo = { ...obrazec } as Record<string, unknown>;
  const izpolnjeno: string[] = [];
  const razlike: Razlika[] = [];
  for (const [k, v] of Object.entries(prebrano)) {
    if (v === undefined || v === null || !(k in oznake)) {
      continue;
    }
    if (prazno(novo[k])) {
      novo[k] = v;
      izpolnjeno.push(k);
    } else if (!enako(novo[k], v)) {
      razlike.push({ kljuc: k, oznaka: oznake[k]!, trenutno: novo[k], prebrano: v });
    }
  }
  return { obrazec: novo as T, izpolnjeno, razlike };
}

/** Stanje umetne inteligence podjetja (ali se lahko uporabi zdaj, sicer zakaj ne; točke). */
export function useAiStanje(omogoceno = true) {
  return useQuery({
    queryKey: ['ai-stanje'],
    enabled: omogoceno,
    queryFn: ({ signal }) => podatki(api.GET('/api/ai/stanje', { signal })),
  });
}
